<template>
	<div class="order-pay">
		<!-- 收银出票-订单详情以及支付 -->
		<a-modal
		title="提示"
		:visible="visiblePayOrder"
		@cancel="closeOrder"
		centered
		:width="900"
		:maskClosable="false"
		:destroyOnClose="true"
		class="order-info-modal no-footer-border"
        :bodyStyle="{paddingBottom: '4px'}"
		>
			<a-row>
				<a-col :span="6">订单状态：{{$utils.transState[orderInfo.transState]}}</a-col>
				<a-col :span="10">交易订单号：{{orderInfo.transNo}}</a-col>
			</a-row>
			<div class="mt24">
				<div class="bg-white">
					<a-table bordered :columns="goodsListColumns" :scroll="{y: 300}" :dataSource="orderInfo.goods" :rowKey="(record,index) => index" :pagination="false">
						<template slot="order" slot-scope="text,record,index">{{index + 1}}</template>
						<template slot="price" slot-scope="text,record,index">{{$utils.toFixed(text, 2)}}</template>
						<template slot="total" slot-scope="text,record,index">
							{{(record.price * record.count).toFixed(2)}}
						</template>
					</a-table>
				</div>
				<a-row class="mt16">
					<a-col :span="8">订单合计：{{$utils.toFixed(orderInfo.transAmount)}}</a-col>
					<a-col :span="8">购买者手机号：{{orderInfo.phone}}</a-col>
					<a-col class="text-right" :span="8">购买者名称：{{orderInfo.phone || '-'}}</a-col>
				</a-row>
			</div>
            <a-divider style="margin: 12px 0 11px 0;background: #EEEEEE;"></a-divider>
			<div class="pay-info-container">
                <div class="text-fail mb8">
                    注意：管理后台仅支持线下收款，无法走系统收款。如需走系统收款，请至收银台操作并选择扫码支付。
                </div>
				<div class="font-big mb16" style="color:#FC7D4F;">
					<span>应收款/元：{{$utils.toFixed(orderInfo.payAmount)}}</span>
					<span class="ml24">优惠金额：{{$utils.toFixed(orderInfo.discountAmount) || '-'}}</span>
				</div>
				<div class="pb16">
					<a-radio-group v-model="payMode">
<!--                        <a-radio :value="0">大后台</a-radio>-->
<!--						<div class="mb8"></div>-->
<!--						<a-radio :value="4">现金</a-radio>-->
<!--						<div class="mb8"></div>-->
<!--						<a-radio :value="3">POS机</a-radio>-->
<!--						<div class="mb8"></div>-->
<!--						<a-radio :disabled="disabledStoreValue" :value="6">储值</a-radio>-->
                        <a-radio :value="9">支付宝-线下</a-radio>
                        <div class="mb8"></div>
                        <div class="mb8" v-if="payMode === 9">
                            <span class="text-fail">*</span>
                            支付宝订单号：
                            <a-input style="width: 400px;" v-model="thirdOrderNo" placeholder="请输入支付宝账单页28位订单号"></a-input>
                        </div>
                        <a-radio :value="10">微信-线下</a-radio>
                        <div class="mb8"></div>
                        <div class="mb8"  v-if="payMode === 10">
                            <span class="text-fail">*</span>
                            微信订单号：
                            <a-input style="width: 400px;" v-model="thirdOrderNo" placeholder="请输入微信账单页28位订单号"></a-input>
                        </div>
                        <a-radio :value="0">无需支付</a-radio>
					</a-radio-group>
				</div>
			</div>
			<template slot="footer">
				<a-button type="primary" @click="closeOrder" style="width:97px" ghost>取消</a-button>
				<a-button type="primary" @click="openPayConfirm" style="width:97px">去支付</a-button>
			</template>
		</a-modal>
        <!-- 收银出票-非支付宝微信支付成功-->
        <a-modal
        title="提示"
        :visible="visibleSuccess"
        @ok="payOrder"
        @cancel="visibleSuccess=!visibleSuccess"
        centered
        :width="576"
        :confirmLoading="confirmLoading"
        :maskClosable="false"
        >
            <div class="font-biggest mb32 mt32">您确定顾客支付成功了吗？</div>
        </a-modal>
        <!-- 收银出票-扫码枪-付款码-->
        <a-modal
        :visible="visiblePayCode"
        @ok="payOrder"
        @cancel="visiblePayCode=!visiblePayCode"
        centered
        :maskClosable="false"
        :width="600"
        :confirmLoading="confirmLoading"
        :destroyOnClose="true"
        :closable="false"
        >
            <a-form :form="payCodeForm" class="text-center">
                <img style="width:400px;" src="@/assets/image/icon_scan_qr_code.png" alt="">
                <div class="font-big text-color-85 mb16">请使用扫码枪扫描顾客付款码</div>
                <a-form-item style="margin:0;" label="付款码：" :labelCol="{span:4}" :wrapperCol="{span:19}">
                    <a-input v-show="false" type="password" autocomplete="new-password" v-decorator="['qrCode',{rules:[{required:true, message:'支付二维码不能为空！'}]}]" placeholder="请输入"/>
                    <scan-input ref="payCodeScanInput" v-if="visiblePayCode" :autofocus="true" @input="qrCodeModalInput"></scan-input>
                </a-form-item>
            </a-form>
        </a-modal>
	</div>
</template>

<script type="text/javascript">
import userInfoTool from "@/plugins/user-info-tool";

// @goodsListColumns 订单表头
const goodsListColumns = [
    {
        title:"序号",
        scopedSlots: {customRender : "order"},
        width: 100
    },
    {
        title:"商品名称",
        dataIndex:"goodsName",
        width: 400
    },
    {
        title:"商品单价",
        dataIndex:"price",
        width: 100,
        scopedSlots: {customRender : "price"},
    },
    {
        title:"购买数量",
        dataIndex:"count",
        width: 100
    },
    {
        title:"合计/元",
        scopedSlots: {customRender : "total"},
        width: 100

    }
]
export default {
    name: "orderPay",
    zh: "订单支付组件",
    data() {
		return {
			orderId: '',
			goodsListColumns,
			confirmLoading: false,
			visibleSuccess: false,
            visiblePayOrder: false,
            visiblePayCode: false,
            orderInfo: {transAmount: 0,},
            payMode: 0,
            userId: "",
            thirdOrderNo: ""
		};
    },
    props: {
        disabledStoreValue: {
            type: Boolean,
            default: false
        }
	},
	watch: {
		orderId(newVal,oldVal) {
			this.viewOrder();
		},
        payMode() {
		    this.thirdOrderNo = "";
        }
	},
    methods:{
		/**
         * @viewOrder 创建订单后获取订单信息
         */
        viewOrder() {
            this.$api.order.tradeDetail({
                params: {
                    transNo: this.orderId
                }
            }).then(res => {
                this.orderInfo = res;
                this.visiblePayOrder = true;
            });
        },
        payOrder () {
            if (this.confirmLoading) {
                return false;
            }
			var payData = {
                    transNo: this.orderId,
                    userId: this.userId,
                    payMode: this.payMode,
                }
            if(this.payMode === 1 || this.payMode === 2 || this.payMode === 6) {
                const qrCode = this.payCodeForm.getFieldValue('qrCode')
                if (!Boolean(qrCode)) {
                    this.payCodeForm.setFields({['qrCode']: {errors: [{required: true, message: '支付二维码不能为空！'}]}});
                    return false;
                }
                payData.qrCode = this.payCodeForm.getFieldValue('qrCode');
            }
            if (this.payMode === 9 || this.payMode === 10) {
                payData.qrCode = this.thirdOrderNo;
            }
			this.pay(payData);
        },
        pay (payData) {
            this.confirmLoading = true;
            this.$api.order.payAfterSalesOrder({
                body:payData
            }).then(res => {
                this.confirmLoading	= false;
                this.visibleSuccess	= false;
                this.visiblePayOrder = false;
                this.visiblePayCode = false;
                this.ticketDetail = {};
                this.$message.success('操作成功');
				this.$emit('payCallback');
            }).catch(res => {
                this.confirmLoading=false;
                this.$refs.payCodeScanInput.value = '';
                this.payCodeForm.resetFields();
            })
        },
        /**
         * @确认支付 确认支付
         */
        openPayConfirm() {
            if(this.confirmLoading) {
                return false;
            }
            if (this.payMode === 9) {
                if (!Boolean(this.thirdOrderNo)) {
                    this.$message.error("请输入支付宝订单号");
                    return false;
                }
            }
            if (this.payMode === 10) {
                if (!Boolean(this.thirdOrderNo)) {
                    this.$message.error("请输入微信订单号");
                    return false;
                }
            }
            if(this.payMode === 1 || this.payMode === 2 || this.payMode === 6){
                this.visiblePayCode = true;
            }else{
                this.visibleSuccess = true;
            }
        },
        /**
         * @closeOrder 关闭订单
         */
        closeOrder() {
            this.visiblePayOrder = false;
        },
        /**
         * 二维码录入
         */
        qrCodeModalInput(val) {
            this.payCodeForm.setFieldsValue({qrCode: val});
        },
    },
    beforeCreate() {
        this.payCodeForm = this.$form.createForm(this);
        this.loginInfo = {
            shopId: sessionStorage.getItem('currentShopId'),
            shopName: sessionStorage.getItem('currentShopName'),
        }
    },
    mounted() {
    }
};
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
